  <div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
      <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
          <span class="title dialog-title">{{title}}</span>
          <button mat-icon-button class="mat-icon-button white-fg"
                  (click)="dialogRef.close()"
                  aria-label="Close dialog">
              <mat-icon>close</mat-icon>
          </button>
      </div>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>
    <form class="addDialog" fxLayout="column" fxFlex>
        <div class="details mat-white-bg px-0 py-0">
        <div class="card mb-0 p-8">
        <div class="item"><div class="label">Summary:</div><div class="value">{{data?.summary}}</div></div>
        <div class="item"><div class="label">Type:</div><div class="value">{{data?.type}}</div></div>
        <div class="item"><div class="label">Date Time:</div><div class="value">{{data?.dateCreated | date: 'dd/MMM/yyyy HH:mm:ss'}}</div></div>
        <div class="item"><div class="label">User:</div><div class="value">{{data?.createdBy?.fullName}}</div></div>
        </div>
        </div>
        <div class="details mat-white-bg">
            <pre [innerHtml]="details | prettyjson:3"></pre>
        </div>
    </form>
  </div>
